module.exports = __webpack_public_path__ + "img/Page1A.2ab35ac7.jpg";